import React from 'react';

type Props = {
  children: React.ReactNode;
  className?: string;
};

/** Shared horizontal action row for page headers — baseline-aligned controls. */
export default function PageHeaderActions({ children, className }: Props) {
  return (
    <div className={['page-header-actions', 'page-header-actions--row', className].filter(Boolean).join(' ')}>
      {children}
    </div>
  );
}
